import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '@constants/queryKey';
import { fetchDocClasses } from '@repository/docClassesRepository';
import { minutesToMillis } from '@utils/millis';
import { useEffect } from 'react';
import log, { LogContext } from '@utils/logging';
import { useAtom } from 'jotai';
import { currentDocClassAtom } from '@js/store/appAtoms';
import { FetchDocClassesError, FetchDocClassesResponse } from '@models/docClasses/FetchDocClasses';

const useFetchDocClasses = () => {
    const [currentDocClass, setCurrentDocClass] = useAtom(currentDocClassAtom);

    const query = useQuery<FetchDocClassesResponse, FetchDocClassesError>({
        queryKey: [QueryKey.DocClasses],
        queryFn: ({ signal }) => fetchDocClasses({ signal }),
        staleTime: minutesToMillis(30),
    });

    const docClasses = query.data;
    const currentDocClassItem = docClasses && !!docClasses.list ? docClasses.list.find((docClassItem) => docClassItem.name === currentDocClass) : undefined;

    useEffect(() => {
        if (!docClasses?.list || docClasses.list.length === 0) {
            return;
        }

        if (currentDocClassItem) {
            return;
        }

        log({
            context: LogContext.CurrentDocClass,
            title: 'Set current docClass to default',
            reason: "User didn't have an existing docClass",
            data: {
                newDocClass: docClasses.list[0].name,
            },
        });
        setCurrentDocClass(docClasses.list[0].name);
    }, [docClasses, currentDocClassItem]);

    return query;
};

export default useFetchDocClasses;
